module.exports = __webpack_public_path__ + "static/img/logowhite.bf325639.png";